// authentication
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const SET_USER_ID = 'SET_USER_ID'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_USER = 'SET_USER'
export const ADD_ACTION = 'ADD_ACTION'
export const DEL_ACTION = 'DEL_ACTION'
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE'

// Error handler
export const SET_ERROR_MSG = 'SET_ERROR_MSG'
export const SET_INFO_MSG = 'SET_INFO_MSG'
export const SET_SUCCESS_MSG = 'SET_SUCCESS_MSG'

// router
export const SET_MODAL_NAME = 'SET_MODAL_NAME'
export const SET_ROUTER_NAME = 'SET_ROUTER_NAME'
export const SET_ROUTER_PARAM = 'SET_ROUTER_PARAM'

// filter
export const SET_SORT_BY = 'SET_SORT_BY'
export const CLEAR_SORT_BY = 'CLEAR_SORT_BY'

export const ADD_FILTER_BY_CATEGORY = 'ADD_FILTER_BY_CATEGORY'
export const REMOVE_FILTER_BY_CATEGORY = 'REMOVE_FILTER_BY_CATEGORY'
export const CLEAR_FILTER_BY_CATEGORY = 'CLEAR_FILTER_BY_CATEGORY'

export const ADD_FILTER_BY_COLOR = 'ADD_FILTER_BY_COLOR'
export const REMOVE_FILTER_BY_COLOR = 'REMOVE_FILTER_BY_COLOR'
export const CLEAR_FILTER_BY_COLOR = 'CLEAR_FILTER_BY_COLOR'

export const ADD_FILTER_BY_BRAND = 'ADD_FILTER_BY_BRAND'
export const REMOVE_FILTER_BY_BRAND = 'REMOVE_FILTER_BY_BRAND'
export const CLEAR_FILTER_BY_BRAND = 'CLEAR_FILTER_BY_BRAND'

export const CLEAR_ALL = 'CLEAR_ALL'

// create
export const SET_LOADING_STATUS = 'SET_LOADING_STATUS'
export const SET_EDIT_MODE = 'SET_EDIT_MODE'

export const SET_CURRENT_VIEW = 'SET_CURRENT_VIEW'
export const SET_STEP = 'SET_STEP'
export const SET_TOPIC_ID = 'SET_TOPIC_ID'

export const INSERT_BLOCK = 'INSERT_BLOCK'
export const UPDATE_BLOCK = 'UPDATE_BLOCK'
export const DELETE_BLOCK = 'DELETE_BLOCK'
export const SET_BLOCKS = 'SET_BLOCKS'
export const SET_BLOCK_ID = 'SET_BLOCK_ID'

export const SET_ISSUE = 'SET_ISSUE'
export const SET_TITLE = 'SET_TITLE'
export const SET_TYPE = 'SET_TYPE'

export const ADD_IMAGE = 'ADD_IMAGE'
export const DELETE_IMAGE = 'DELETE_IMAGE'

export const ADD_PRODUCT = 'ADD_PRODUCT'
export const DELETE_PRODUCT = 'DELETE_PRODUCT'

export const ADD_BRAND = 'ADD_BRAND'
export const DELETE_BRAND = 'DELETE_BRAND'

export const SET_COLOR = 'SET_COLOR'

export const ADD_TAG = 'ADD_TAG'
export const DELETE_TAG = 'DELETE_TAG'

// create/block
export const SET_SHOW_BLOCK_MODAL = 'SET_SHOW_BLOCK_MODAL'
export const SET_ACTION = 'SET_ACTION'
export const SET_ORDER = 'SET_ORDER'
export const SET_DATA = 'SET_DATA'
